module.exports = __webpack_public_path__ + "static/media/train-0-0-car.81bbc0bd.png";